export default "__VITE_PUBLIC_ASSET__9eb50859__"